import { Component, HostListener, ElementRef } from '@angular/core';
import { trigger, style, transition, animate } from '@angular/animations';
import { QueryService } from '../services/query.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MisdatosService } from '../services/misdatos.service';
import { ProductosService } from '../services/productos.service';
import { Producto } from '../models/producto.model';
import { moveItemInArray, CdkDragDrop } from '@angular/cdk/drag-drop';
import { WebsocketService } from '../services/websocket.service';
import { ToastrService } from 'ngx-toastr';
import { FuncionesService } from '../services/funciones';
// Definimos un tipo estricto para los campos permitidos
type CamposOrdenables = 'pr_orden' | 'pr_producto' | 'pr_fechahora_add' | 'pr_id_user';

@Component({
  selector: 'app-productos',
  templateUrl: './productos.component.html',
  styleUrl: './productos.component.css',
  animations: [
    trigger('desaparecer', [
      // 1. Animación al aparecer (Opcional, por si quieres que entre suave)
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate(
          '300ms ease-out',
          style({ opacity: 1, transform: 'translateY(0)' }),
        ),
      ]),

      // 2. LA CLAVE: Animación al desaparecer (Clic en comprado)
      transition(':leave', [
        // 1. Forzamos los estilos de "en-cesta" justo al empezar a irse
        style({
          backgroundColor: 'transparent',
          /*textDecoration: 'line-through', // Si estaba tachado*/
          opacity: 1,
        }),

        // 2. Ejecutamos la animación hacia abajo
        animate(
          '400ms ease-in-out',
          style({
            opacity: 0,
            transform: 'translateY(30px)',
            height: '0px',
            paddingTop: '0px',
            paddingBottom: '0px',
          }),
        ),
      ]),
    ]),
  ],
})
export class ProductosComponent {
  private misdatosSub!: Subscription;
  misdatos: any = {};
  productos: any[] = [];
  productosNoCesta: any[] = [];
  productosEnCesta: any[] = [];
  productoSeleccionado: Producto = {
    IDID: 0,
    pr_id: 0,
    pr_li_id: 0,
    pr_producto: '',
    pr_check: '',
    pr_fecha_add: '',
    pr_hora_add: '',
    pr_fechahora_add: '',
    pr_borrado: '',
    pr_comprado: '',
    pr_orden: 0,
    pr_id_user: 0,
    pr_id_user_check: 0,
    pr_precio: 0,
  };
  productonuevo: string = '';
  li_id: number = 0;
  busy: boolean = false;
  private wsSubscription!: Subscription;
  // Guardamos qué campo está ordenado y en qué dirección
  campoActual: keyof Producto | '' = '';
  esAscendente: boolean = true;

  constructor(
    public misdatosService: MisdatosService,
    private query: QueryService,
    public productosService: ProductosService,
    private elementRef: ElementRef,
    private wsService: WebsocketService,
    private toastr: ToastrService,
    public funciones: FuncionesService,
  ) {}

  ngOnInit(): void {
    // 1. Escuchamos el observable
    this.misdatosSub = this.misdatosService.misdatos$
      .pipe(
        // 2. FILTRO: Si es null, no pasa. Solo continúa si tiene datos reales.
        filter((misdatos): misdatos is any => misdatos !== null),
      )
      .subscribe((misdatos: any) => {
        // Ya tenemos datos
        this.misdatos = misdatos;
        this.getProductos();
      });

    // Nos quedamos escuchando de forma persistente
    this.wsSubscription = this.wsService.escucharNotificaciones().subscribe({
      next: (data) => {
        // Aquí haces lo que quieras: meterlo en un array, lanzar un toast/alerta visual, etc.
        //this.listaNotificaciones.push(data);
        if (data.tipo == 'GETPRODUCTOS' && data.ID != this.misdatos.ID) {
          if (data.mensaje != '')
            this.toastr.success(data.mensaje);
          this.getProductos();
        } else if (data.tipo == 'GETPRODUCTOS_ALLUSERS') {
          this.getProductos();
        }
      },
      error: (err) => console.error(err),
    });
  }

  ngOnDestroy() {
    // Buenas prácticas: nos desuscribimos al destruir el componente para evitar fugas de memoria
    if (this.wsSubscription) {
      this.wsSubscription.unsubscribe();
    }
  }

  getProductos() {
    this.query.query('productos', 'GET', null).subscribe((resultado: any) => {
      this.li_id = resultado.li_id;
      this.productos = resultado.registros;
      this.marcarPosiblesRepetidos();
      this.marcarProductosAntiguos();
      this.productosNoCesta = this.getProductosCheck('');
      this.productosEnCesta = this.getProductosCheck('X');
      this.reordenar();
      this.productosService.setProductos(this.productos);
      // 1. Intentamos recuperar las preferencias guardadas en localStorage
      const campoGuardado = localStorage.getItem('prod_campo_orden') as CamposOrdenables | null;
      const direccionGuardada = localStorage.getItem('prod_orden_asc');

      if (campoGuardado) {
        this.campoActual = campoGuardado;
        // localStorage guarda todo como string, lo convertimos a boolean
        this.esAscendente = direccionGuardada === 'true';
        
        // 2. Si hay productos ya cargados, ejecutamos el ordenamiento inicial.
        // Si tus productos vienen de una API/Servicio de forma asíncrona, 
        // asegúrate de llamar a `this.aplicarOrdenamiento()` justo después de que la API te devuelva los datos.
        if (this.productos.length > 0) {
          this.aplicarOrdenamiento();
        }
      }
    });
  }

  getProductosCheck(check: string = '') {
    return this.productos.filter((item) => item.pr_check === check && item.pr_borrado === '');
  }

  getProductosBorrados() {
    return this.productos.filter((item) => item.pr_borrado === 'X');
  }

  sendNotificacion(tipo: string = '', mensaje: string = '') {
    // Enviar notificación al websocket
    const notificacion = {
      tipo: tipo,
      ID: this.misdatos.ID,
      mensaje: mensaje,
    };
    // Esto viaja al servidor Node.js
    this.wsService.enviarNotificacion(notificacion);
  }

  addProducto() {
    if (this.productonuevo.trim() != '') {
      this.busy = true;
      this.initProducto();
      this.productoSeleccionado.pr_id = 0;
      this.productoSeleccionado.pr_li_id = this.li_id;
      this.productoSeleccionado.pr_id_user = this.misdatos.ID;
      this.productoSeleccionado.pr_producto = this.productonuevo;
      this.productoSeleccionado.pr_check = '';
      this.productonuevo = '';
      this.query
        .query('productos', 'SAVE', this.productoSeleccionado)
        .subscribe((resultado: any) => {
          this.sendNotificacion('GETPRODUCTOS', this.misdatos.first_name + ' ha añadido un nuevo producto');
          this.query.query('productos', 'GET', { pr_id: resultado.registro.pr_id }).subscribe((resultado: any) => {
            this.productosService.addProducto(resultado.registros[0]);
            // Le pides al servicio el nuevo array que acaba de crear
            this.productos = this.productosService.getProductos();
            this.marcarPosiblesRepetidos();
            this.productosNoCesta = this.getProductosCheck('');
            //this.productosEnCesta = this.getProductosCheck('X');
            this.reordenar();
            //this.getProductos();
            this.busy = false;
          });
        });
    }
  }

  guardarProducto(producto: any) {
    producto.busy = true;
    this.query
      .query('productos', 'SAVE', producto)
      .subscribe((resultado: any) => {
        this.sendNotificacion('GETPRODUCTOS');
        producto.busy = false;
      });
  }

  guardarProductos() {
    this.query
      .query('productos', 'SAVEALL', this.productos)
      .subscribe((resultado: any) => {
        this.sendNotificacion('GETPRODUCTOS');
      });
  }

  checkProducto(producto: any) {
    producto.busy = true;
    producto.pr_check = producto.pr_check == '' ? 'X' : '';
    this.query
      .query('productos', 'SAVE', producto)
      .subscribe((resultado: any) => {
        this.productosNoCesta = this.getProductosCheck('');
        this.productosEnCesta = this.getProductosCheck('X');
        producto.busy = false;
        this.reordenar();
        this.sendNotificacion('GETPRODUCTOS');
      });
  }

  editarProducto(producto: any) {
    this.productoSeleccionado = producto;
  }

  seleccionarItem(producto: any, event: Event) {
    // Evitamos que el click se propague si hacen click directo en la papelera
    event.stopPropagation();

    // Si vuelven a tocar el mismo, se oculta. Si no, se activa el nuevo.
    this.productoSeleccionado =
      this.productoSeleccionado === producto ? null : producto;
  }

  borrarProducto(producto: any) {
    producto.busy = true;
    this.query
      .query('productos', 'BORRARPRODUCTO', producto)
      .subscribe((resultado: any) => {
        this.initProducto();
        this.getProductos();
        this.sendNotificacion('GETPRODUCTOS');
      });
  }

  // ESCUCHADOR DE SCROLL GLOBAL
  @HostListener('window:scroll', [])
  alHacerScroll(): void {
    this.initProducto();
  }

  initProducto() {
    this.productoSeleccionado = {} as Producto;
    this.productoSeleccionado = {
      IDID: 0,
      pr_id: 0,
      pr_li_id: this.li_id,
      pr_producto: '',
      pr_check: '',
      pr_fecha_add: '',
      pr_hora_add: '',
      pr_fechahora_add: '',
      pr_borrado: '',
      pr_comprado: '',
      pr_orden: 0,
      pr_id_user: 0,
      pr_id_user_check: 0,
      pr_precio: 0,
    };
  }

  // Añade esta función dentro de tu componente .ts
  trackPorId(index: number, producto: any): number {
    return producto.pr_id; // Cambia 'pr_id' por el identificador único de tu producto (id, pr_codigo, etc.)
  }

  ordenarProductos(event: CdkDragDrop<any[]>): void {
    // 1. Reordenamos el array local en memoria automáticamente
    moveItemInArray(
      this.productosNoCesta,
      event.previousIndex,
      event.currentIndex,
    );

    this.reordenar();

    this.guardarProductos();
  }

  reordenar() {
    // 1. Primero calculas los órdenes en 'productosNoCesta' como ya hacías
    this.productosNoCesta.forEach((prod, index) => {
      prod.pr_orden = index;
    });

    // 2. Creas un mapa rápido de ID -> pr_orden
    const ordenMap = new Map(
      this.productosNoCesta.map((p) => [p.pr_id, p.pr_orden]),
    );

    // 3. Actualizas 'this.productos' en una sola pasada eficiente
    this.productos.forEach((prod) => {
      if (ordenMap.has(prod.pr_id)) {
        prod.pr_orden = ordenMap.get(prod.pr_id);
      }
    });
  }

  recuperarProducto(producto: any) {
    producto.busy = true;
    producto.pr_borrado = '';
    this.query
      .query('productos', 'SAVE', producto)
      .subscribe((resultado: any) => {
        this.productosNoCesta = this.getProductosCheck('');
        this.productosEnCesta = this.getProductosCheck('X');
        producto.busy = false;
        this.reordenar();
        this.sendNotificacion('GETPRODUCTOS');
      });
  }

ordenarPor(campo: CamposOrdenables): void {
    if (this.campoActual === campo) {
      this.esAscendente = !this.esAscendente;
    } else {
      this.campoActual = campo;
      this.esAscendente = true;
    }

    // Guardamos la elección actual en el localStorage del navegador
    localStorage.setItem('prod_campo_orden', this.campoActual);
    localStorage.setItem('prod_orden_asc', String(this.esAscendente));

    this.aplicarOrdenamiento();
  }

  /**
   * Esta función separada realiza la lógica pura de ordenamiento sobre el array
   */
  private aplicarOrdenamiento(): void {
    if (!this.campoActual) return;

    const campo = this.campoActual;

    this.productosNoCesta = [...this.productosNoCesta].sort((a, b) => {
      let valorA = a[campo];
      let valorB = b[campo];

      if (valorA === undefined || valorA === null) return this.esAscendente ? 1 : -1;
      if (valorB === undefined || valorB === null) return this.esAscendente ? -1 : 1;

      // Ordenación de strings (pr_producto, pr_fechahora_add)
      if (typeof valorA === 'string' && typeof valorB === 'string') {
        return this.esAscendente 
          ? valorA.localeCompare(valorB, undefined, { numeric: true, sensitivity: 'base' })
          : valorB.localeCompare(valorA, undefined, { numeric: true, sensitivity: 'base' });
      }

      // Ordenación de números (pr_orden, pr_id_user)
      if (typeof valorA === 'number' && typeof valorB === 'number') {
        return this.esAscendente ? valorA - valorB : valorB - valorA;
      }

      return 0;
    });
  }

// Algoritmo estándar de Levenshtein
  private calcularLevenshtein(a: string, b: string): number {
    const matrix = [];
    for (let i = 0; i <= b.length; i++) matrix[i] = [i];
    for (let j = 0; j <= a.length; j++) matrix[0][j] = j;

    for (let i = 1; i <= b.length; i++) {
      for (let j = 1; j <= a.length; j++) {
        if (b.charAt(i - 1) === a.charAt(j - 1)) {
          matrix[i][j] = matrix[i - 1][j - 1];
        } else {
          matrix[i][j] = Math.min(
            matrix[i - 1][j - 1] + 1, // Sustitución
            matrix[i][j - 1] + 1,     // Inserción
            matrix[i - 1][j] + 1      // Eliminación
          );
        }
      }
    }
    return matrix[b.length][a.length];
  }

  marcarPosiblesRepetidos(): void {
    // Inicializamos todos como falsos por seguridad
    this.productos.forEach(p => p.esRepetido = false);

    // Umbral de tolerancia: 1 o 2 caracteres de diferencia suele ser un error tipográfico
    const UMBRAL_TOLERANCIA = 2; 

    for (let i = 0; i < this.productos.length; i++) {
      if (this.productos[i].pr_borrado == '') {
        for (let j = i + 1; j < this.productos.length; j++) {
          if (this.productos[j].pr_borrado == '') {
            const prodA = this.productos[i];
            const prodB = this.productos[j];

            const textoA = prodA.pr_producto.toLowerCase().trim();
            const textoB = prodB.pr_producto.toLowerCase().trim();

            // 1. Calculamos Levenshtein para errores de dedo
            const distancia = this.calcularLevenshtein(textoA, textoB);

            // 2. REGLA EXTRA: Verificar si uno contiene al otro
            const unoContieneAlOtro = textoA.includes(textoB) || textoB.includes(textoA);

            // Si están dentro del rango de error, marcamos AMBOS como posibles repetidos
            if ((distancia > 0 && distancia <= UMBRAL_TOLERANCIA) || unoContieneAlOtro) {
              this.productos[i].esRepetido = true;
              this.productos[i].posibleGemelo = prodB.pr_producto;

              this.productos[j].esRepetido = true;
              this.productos[j].posibleGemelo = prodA.pr_producto;
            }
          }
        }
      }
    }
  }

  marcarProductosAntiguos(): void {
    const haceSeisMeses = new Date();
    haceSeisMeses.setMonth(haceSeisMeses.getMonth() - 6);

    this.productos = this.productos.map(producto => {
      // Convertimos a objeto Date si viene como string
      const fechaProducto = new Date(producto.pr_fechahora_add);
      
      return {
        ...producto,
        // Si la fecha del producto es MENOR que la fecha de hace 6 meses, tiene más de 6 meses de antigüedad
        esAntiguo: fechaProducto < haceSeisMeses
      };
    });
  }

}
